/* lua.js generated code 0.3.0 */

require("clover/panel/component/common/UIGroupButton")
UIGIconDiscountLabelButton = xClass("UIGIconDiscountLabelButton", UIGroupButton, function (node) {
    return node
})
UIGIconDiscountLabelButton.prototype.setString = function (str) {
    var self = this
    var bg = self.getChildByName("normal")
    var bgSize = bg.getContentSize()
    ;[bgSize.width, bgSize.height] = [bgSize.width - 10.9, bgSize.height - 22.35]
    var [xOffset, yOffset] = [0, 1]
    var label = self.getChildByName("label")
    label.ignoreContentAdaptWithSize(true)
    label.setString(str)
    var size = label.getVirtualRendererSize()
    var scale = label.getScale()
    label.setPositionY(bg.getPositionY() - (bgSize.height - size.height * scale) * 3 / 5 - yOffset)
    self.refreshLayout()
}
UIGIconDiscountLabelButton.prototype.setNum = function (str) {
    var self = this
    var bg = self.getChildByName("normal")
    var bgSize = bg.getContentSize()
    ;[bgSize.width, bgSize.height] = [bgSize.width - 10.9, bgSize.height - 22.35]
    var [xOffset, yOffset] = [0, 5]
    var label = self.getChildByName("num")
    label.ignoreContentAdaptWithSize(true)
    label.setString(str)
    var size = label.getVirtualRendererSize()
    var scale = label.getScale()
    label.setPositionY(bg.getPositionY() - (bgSize.height - size.height * scale) * 25 / 39 - yOffset)
    self.refreshLayout()
}
UIGIconDiscountLabelButton.prototype.setNum2 = function (str) {
    var self = this
    var bg = self.getChildByName("normal")
    var bgSize = bg.getContentSize()
    ;[bgSize.width, bgSize.height] = [bgSize.width - 10.9, bgSize.height - 22.35]
    var [xOffset, yOffset] = [0, 5]
    var label = self.getChildByName("num2")
    label.ignoreContentAdaptWithSize(true)
    label.setString(str)
    var size = label.getVirtualRendererSize()
    var scale = label.getScale()
    label.setPositionY(bg.getPositionY() - (bgSize.height - size.height * scale) * 3 / 39 - yOffset)
    var line = self.getChildByName("line")
    line.setScaleX((size.width + 20) / line.getContentSize().width)
    line.setPositionY(label.getPositionY() - size.height * 8 / 15)
    self.refreshLayout()
}
UIGIconDiscountLabelButton.prototype.setIcon = function (sprite) {
    var self = this
    var bg = self.getChildByName("normal")
    var bgSize = bg.getContentSize()
    ;[bgSize.width, bgSize.height] = [bgSize.width - 10.9, bgSize.height - 22.35]
    var [xOffset, yOffset] = [0, 0]
    var icon = self.getChildByName("icon")
    var iSize = icon.getContentSize()
    icon.setPositionY(bg.getPositionY() - bgSize.height / 2 - yOffset)
    var size = sprite.getContentSize()
    sprite.setScale(size.width / iSize.width * icon.getScale())
    sprite.setName("icon")
    sprite.setPosition(cc.p(icon.getPosition()))
    icon.removeFromParent(true)
    self.addChild(sprite)
    self.refreshLayout()
}
// 刷新横向布局
UIGIconDiscountLabelButton.prototype.refreshLayout = function () {
    var self = this
    var bg = self.getChildByName("normal")
    var bSize = bg.getContentSize()
    ;[bSize.width, bSize.height] = [bSize.width - 10.9, bSize.height - 22.35]
    var icon = self.getChildByName("icon")
    var iSize = icon.getContentSize()
    var num = self.getChildByName("num")
    var num2 = self.getChildByName("num2")
    var nSize = num.getContentSize()
    var nSize2 = num2.getContentSize()
    var nWidth = Math.max(nSize2.width + 20, nSize.width)
    var label = self.getChildByName("label")
    var lSize = label.getContentSize()
    var totalWidth = iSize.width * icon.getScale() + Math.max(nWidth, 60) + lSize.width
    margin = Math.max(Math.min((bSize.width - totalWidth - 30) / 2, 15), 5)
    num.setPositionX(icon.getPositionX() + iSize.width * icon.getScale() / 2 + margin + (Math.max(nWidth, 60) - nSize.width) / 2)
    num2.setPositionX(icon.getPositionX() + iSize.width * icon.getScale() / 2 + margin + (Math.max(nWidth, 60) - nSize2.width) / 2)
    label.setPositionX(icon.getPositionX() + iSize.width * icon.getScale() / 2 + margin * 2 + Math.max(nWidth, 60))
    var line = self.getChildByName("line")
    if (line) {
        line.setPositionX(num2.getPositionX() - 10)
    }
}
